<template>
    <div>
        <div class="content-header text-center">
            <h2>Recent Activity</h2>
            <p>Logged events from the past 72 hours</p>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div class="col">
                    <pre style="white-space: pre-line">
                        {{this.log}}
                    </pre>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'Recent Activity',
    props: {
        userData: [],
        isAdmin: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data(){
        return{
           log: []
        }
    },
     methods: { 
        retrieve_log() {
            axios.post('/retrieve_user_log')
                .then(
                (response) => {  
                    this.log = response.data;
                    console.log('returned log '+JSON.stringify(this.log));
                })
                .catch(
                (error) => {
                this.errorMessage = error.message;
                console.error("There was an error", error);
            });
        }
        
    },
    mounted() {
        this.retrieve_log();
    }
};

</script>